const editCheckoutTermsConditionsConstantsAr = {
  termsConditionsPageTitle: 'الشروط والأحكام - تعديل',
  termsConditionsBreadcrumb: 'الشروط والأحكام',
};

export default editCheckoutTermsConditionsConstantsAr;
